import React, { useEffect, useRef } from 'react';

interface CircleProgressProps {
    percent: number; // 进度百分比 (0-100)
    strokeWidth?: number; // 圆环宽度 (默认 8)
    strokeColor?: string; // 进度条颜色 (默认 #3498db)
    trailColor?: string; // 背景条颜色 (默认 #eee)
    className?: string;
}

const CircleProgress: React.FC<CircleProgressProps> = ({
    percent = 0,
    strokeWidth = 12,
    strokeColor = '#3498db',
    trailColor = 'rgba(255,255,255,0.5)',
    className = ''
}) => {
    const circleRef = useRef<SVGCircleElement>(null);
    const size = 150;
    useEffect(() => {
        if (circleRef.current) {
            const radius = circleRef.current.r.baseVal.value;
            const circumference = 2 * Math.PI * radius;

            // 设置圆环的周长和初始偏移
            circleRef.current.style.strokeDasharray = `${circumference}`;
            circleRef.current.style.strokeDashoffset = `${circumference - (percent / 100) * circumference
                }`;
        }
    }, [percent]);

    // 计算半径 (SVG 尺寸减去边框宽度的一半)
    const radius = size / 2 - strokeWidth / 2;
    // 视图框 (viewBox)尺寸 加10防止在safari中被切边
    const viewBox = `0 0 ${size + 10} ${size + 10}`;

    return (
        <div className={className}>
            <svg width="100%" height="100%" viewBox={viewBox} className="progress-svg">
                {/* 背景圆环 */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke={trailColor}
                    strokeWidth={strokeWidth}
                    fill="none"
                />
                {/* 进度圆环 */}
                <circle
                    ref={circleRef}
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                    fill="none"
                    transform={`rotate(-90 ${size / 2} ${size / 2})`} // 从顶部开始
                    style={{
                        transition: 'stroke-dashoffset 0.5s ease-out'
                    }}
                />
            </svg>
        </div>
    );
};

export default CircleProgress;
